import React from 'react';
import './Vimeo.css';

const VIMEO_PLAYER_URL = 'https://player.vimeo.com/video/';
const VIMEO_PARAMETERS = '?background=1&autoplay=1&transparent=0&api=1';

class Vimeo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRefSet: false,
    };

    this.renderVimeoIframe = this.renderVimeoIframe.bind(this);
    this.setRef = this.setRef.bind(this);
  }

  setRef(elem) {
    this.setState({ isRefSet: true });
    this.iframe = elem;
  }

  componentDidMount() {
    import('@vimeo/player').then(({ default: VimeoPlayer }) => {
      const { queuedPlay } = this.state;
      this.player = new VimeoPlayer(this.iframe);
      if (queuedPlay) {
        this.player.ready().then(() => this.player.play());
      }
    });
  }

  renderVimeoIframe() {
    const { videoId } = this.props;

    return (
      <iframe
        title={videoId}
        ref={this.setRef}
        src={`${VIMEO_PLAYER_URL}${videoId}${VIMEO_PARAMETERS}`}
        style={{ width: '100%', height: '100%' }}
        frameBorder="0"
      />
    );
  }


  render() {
    return (
      <div
        className="pdp-vimeo-container"
      >
        {this.renderVimeoIframe()}
      </div>
    );
  }
}
export default Vimeo;



// WEBPACK FOOTER //
// ./src/components/Vimeo/index.js